var _circle, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 214,
    viewBox: "0 0 214 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 106.5,
    r: 55.5,
    fill: "#023E56"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_62_39)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 107,
    r: 75,
    fill: "#57D7FD",
    fillOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.923 111.324C116.067 111.363 116.216 111.387 116.368 111.387C116.554 111.387 116.743 111.356 116.929 111.292C125.327 108.37 131.192 98.3262 131.192 86.8661C131.192 85.9231 130.428 85.1587 129.485 85.1587H123.048C123.072 84.3983 123.089 83.6333 123.089 82.8607C123.089 82.5466 122.834 82.2917 122.52 82.2917H90.422C90.1078 82.2917 89.853 82.5466 89.853 82.8607C89.853 83.6339 89.8699 84.3983 89.8937 85.1587H83.456C82.513 85.1587 81.7485 85.9231 81.7485 86.8661C81.7485 98.3267 87.6144 108.371 96.0132 111.292C96.1988 111.358 96.3879 111.388 96.5741 111.388C96.7259 111.388 96.8742 111.363 97.0179 111.324C98.6213 113.644 100.427 115.396 102.37 116.427V125.525H100.664C98.3554 125.525 96.4769 127.403 96.4769 129.712V131.235H94.5891C93.6461 131.235 92.8816 131.999 92.8816 132.942C92.8816 133.886 93.6461 134.65 94.5891 134.65H118.352C119.295 134.65 120.059 133.886 120.059 132.942C120.059 131.999 119.295 131.235 118.352 131.235H116.464V129.712C116.464 127.404 114.586 125.525 112.277 125.525H110.57V116.427C112.514 115.395 114.32 113.644 115.923 111.324ZM127.73 88.573C127.28 96.5698 123.696 103.507 118.478 106.767C120.732 101.853 122.299 95.5663 122.858 88.573H127.73ZM85.2112 88.573H90.0822C90.6419 95.5663 92.2097 101.853 94.4634 106.768C89.2445 103.508 85.6603 96.5704 85.2112 88.573Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 101.116L102.869 103.303C102.708 103.405 102.541 103.449 102.366 103.434C102.191 103.42 102.038 103.362 101.906 103.259C101.775 103.157 101.673 103.03 101.6 102.877C101.527 102.724 101.513 102.553 101.556 102.363L102.519 98.2282L99.3032 95.45C99.1573 95.3188 99.0663 95.1692 99.0302 95.0012C98.994 94.8332 99.0048 94.6693 99.0625 94.5094C99.1203 94.3496 99.2078 94.2183 99.325 94.1157C99.4423 94.013 99.6027 93.9474 99.8063 93.9188L104.05 93.5469L105.691 89.6532C105.764 89.4782 105.877 89.3469 106.03 89.2594C106.184 89.1719 106.34 89.1282 106.5 89.1282C106.66 89.1282 106.817 89.1719 106.97 89.2594C107.123 89.3469 107.237 89.4782 107.309 89.6532L108.95 93.5469L113.194 93.9188C113.398 93.948 113.558 94.0136 113.675 94.1157C113.792 94.2178 113.879 94.349 113.938 94.5094C113.996 94.6698 114.007 94.834 113.971 95.002C113.935 95.17 113.843 95.3194 113.697 95.45L110.481 98.2282L111.444 102.363C111.488 102.552 111.473 102.724 111.4 102.877C111.327 103.03 111.225 103.158 111.094 103.259C110.963 103.361 110.809 103.419 110.634 103.434C110.459 103.45 110.292 103.406 110.131 103.303L106.5 101.116Z",
    fill: "#247B98"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_62_39",
    x: 0.6,
    y: 0.6,
    width: 212.8,
    height: 212.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.7,
    result: "effect1_foregroundBlur_62_39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT6);
export default __webpack_public_path__ + "static/media/T6.bc4eb659f43afb3d46d32bf3300108b8.svg";
export { ForwardRef as ReactComponent };